import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { PolicyTypeEnum } from '../../enums/policy-type.enum';
import { POLICY_TYPES_BY_SUBJECT } from '../policy-types-by-subject.const';

const policyAssignItemSchema = Joi.object({
	id: Joi.alternatives()
		.conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|policy-assign-id|cannot-be-null',
			}),
			otherwise: Joi.number().required().messages({
				'any.required': 'validations|policy-assign-id|required',
				'number.base': 'validations|policy-assign-id|must-be-number',
			}),
		})
		.required()
		.messages({
			'any.required': 'validations|policy-assign-id|required',
		}),
	type: Joi.alternatives()
		.conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|policy-assign-type|cannot-be-null',
			}),
			otherwise: Joi.string()
				.valid(...Object.values(PolicyTypeEnum))
				.required()
				.messages({
					'any.required': 'validations|policy-assign-type|required',
					'any.only': 'validations|policy-assign-type|invalid-value',
				}),
		})
		.required()
		.messages({
			'any.required': 'validations|policy-assign-type|required',
		}),
});

/**
 * Creates a Joi schema for validating policy assignment arrays per subject.
 * Validates each item has id and type, and type is in allowed types for subject.
 *
 * @param subject - AppSubjectEnum for the record being assigned policies
 * @returns Joi array schema
 */
export const createPoliciesAssignSchema = (subject: AppSubjectEnum) => {
	const allowedTypes = POLICY_TYPES_BY_SUBJECT[subject];
	if (!allowedTypes || allowedTypes.length === 0) {
		return Joi.array().items(policyAssignItemSchema).max(0).optional().allow(null);
	}

	return Joi.array()
		.items(
			policyAssignItemSchema.keys({
				type: Joi.alternatives()
					.conditional(Joi.any().valid(null), {
						then: Joi.invalid(null).messages({
							'any.invalid': 'validations|policy-assign-type|cannot-be-null',
						}),
						otherwise: Joi.string()
							.valid(...allowedTypes)
							.required()
							.messages({
								'any.required': 'validations|policy-assign-type|required',
								'any.only': 'validations|policy-assign-type|invalid-value',
							}),
					})
					.required()
					.messages({
						'any.required': 'validations|policy-assign-type|required',
					}),
			}),
		)
		.optional()
		.allow(null);
};
